import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  FinancialAccount,
  type FinancialAccountConstructor,
} from './FinancialAccount'
import { FinancialAccountStatuses } from '../enums/FinancialAccountStatusEnum'
import { FinancialAccountTypes } from '../enums/FinancialAccountTypeEnum'

export const FinancialAccountConstructorFactory =
  Factory.Sync.makeFactory<FinancialAccountConstructor>({
    id: Factory.each(() => faker.random.number()),
    type: FinancialAccountTypes.AIRWALLEX_USD,
    status: FinancialAccountStatuses.ACTIVE,
  })

export const FinancialAccountFactory = EntityFactory(
  FinancialAccount,
  FinancialAccountConstructorFactory
)
